import create, { SetState } from 'zustand';
import { IUserSignupFormValues, subscribeToNewsletterInitialValue } from '@gik/auth/components/Signup/SignupForm';

// TODO: discuss about move this into UserStore on dev meeting
export interface IAuthStore {
  signupFormValues: Partial<IUserSignupFormValues>;
  setSignupFormValues(values: Partial<IUserSignupFormValues>): void;
}

export const [useAuthStore] = create<IAuthStore>((set: SetState<IAuthStore>) => ({
  signupFormValues: { subscribeToNewsletter: subscribeToNewsletterInitialValue },
  setSignupFormValues: signupFormValues =>
    set(() => {
      return {
        signupFormValues,
      };
    }),
}));
